export var defaultSort = function defaultSort(a, b) {
  if (a.label < b.label) return -1;
  if (a.label > b.label) return 1;
  return 0;
};
export var generateOption = function generateOption(_ref) {
  var maskMap = _ref.maskMap,
      optionList = _ref.optionList,
      makeOption = _ref.makeOption,
      value = _ref.value;

  if (maskMap && value) {
    return maskMap[value];
  }

  if (optionList && value && makeOption) {
    var defaultObject = optionList.find(function (item) {
      return item.value === value;
    }) || {};
    return makeOption(defaultObject);
  }

  return null;
};